import { DeviceTable } from '@/components/device';
import { useDocumentTitle } from '@/hooks/common';

export const DevicesPage = () => {
  useDocumentTitle('Devices');

  return <DeviceTable />;
};
